import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CustomerManageService } from '../shared/customer-manage.service';
import { MVDNowViewDetailComponent } from './mvdnow-view-detail.component';
import { MVDNowViewComponent } from './mvdnow-view.component';
import { MVDNowViewService } from './mvdnow-view.service';
import { TitleViewComponent } from './title-view.component';
import { AssistedSelfServiceInvitationComponent } from './assisted-self-service-invitations/assisted-self-service-invitation-list.component';
import { AssistedSelfServiceInvitationService } from '../../shared/services/assisted-self-service-invitation/assisted-self-service-invitation.service';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { SharedModule } from 'primeng/api';
import { SharedValidatorsModule } from '../../shared/validators/shared-validators.module';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';
import { MVDNowLinkCustomerModalComponent } from './mvdnow-link-customer-modal.component';
import { MVDNowChangeEmailModalComponent } from './mvdnow-change-email-modal.component';
import { MobileIdentificationCredentialActionRequestModalComponent } from './mobile-identification-credential-action-request-modal.component';

@NgModule({
    declarations: [
        MVDNowViewComponent,
        MVDNowViewDetailComponent,
        TitleViewComponent,
        AssistedSelfServiceInvitationComponent,
        MVDNowLinkCustomerModalComponent,
        MVDNowChangeEmailModalComponent,
        MobileIdentificationCredentialActionRequestModalComponent,
    ],
    providers: [
        MVDNowViewService,
        CustomerManageService,
        AssistedSelfServiceInvitationService
    ],
    imports: [
        CommonModule,
        DropdownModule,
        SharedPipesModule,
        ValidationResultsModule,
        TableModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedModule,
        InputMaskModule,
        SharedValidatorsModule,
        SharedComponentsModule
    ],
    exports: [
        MVDNowViewComponent
    ]
})
export class MVDNowViewModule { }
